/* eslint-disable import/prefer-default-export */
import { AnyAction } from 'redux';
import { setRequestStatus } from 'data-layer-cr/dist/network';
import { ServerResponse } from 'data-layer-cr/dist/models';
import { AsyncAppThunk, AsyncDispatch } from 'src/store/ThunkTypes';

import PricingProfileResponse from '../../../models/responseTypes/PricingProfileResponse';
import processRequest from '../../../services/processRequest';
import { REQUEST_PRICING_PROFILES } from '../requestIdentifiers';

import { setPricingProfile } from '../slice/pricingProfileSlice';

export const getPricingProfiles =
  (): AsyncAppThunk =>
  async (dispatch: AsyncDispatch): Promise<AnyAction> => {
    dispatch(setRequestStatus(REQUEST_PRICING_PROFILES, 'requesting'));
    try {
      const result = await processRequest<
        ServerResponse<PricingProfileResponse[]>
      >({
        method: 'GET',
        url: 'Pricing/user/profiles',
      });
      dispatch(setPricingProfile(result.data));
      return dispatch(setRequestStatus(REQUEST_PRICING_PROFILES, 'success'));
    } catch (e) {
      return dispatch(setRequestStatus(REQUEST_PRICING_PROFILES, 'failure'));
    }
  };
